export default "__VITE_ASSET__BORPlJ8C__"